import removeCommas from "./removeCommas";

// simply returns undefined if the input is undefined otherwise uses removeCommas
const removeCommasUnd = (stringNumber: string | undefined) => {
  if (stringNumber === undefined) {
    return undefined;
  }

  return removeCommas(stringNumber);
};

export default removeCommasUnd;
